module.exports = __webpack_public_path__ + "img/silver3.b3d07eac.png";